import { Link } from "react-router-dom";
import { songs } from "../../database/song";
import Layout from "../Layout";
import SongCard from "../SongCard";

function Home() {
  return (
    <>
      <Layout />
      <div className="pl-64 pt-20 pb-40 w-screen  ">
        <h4 className="text-white text-xl font-semibold">Recently Played</h4>
        <div className="flex flex-wrap">
          {songs.slice(0, 4).map((data, index) => {
            return <SongCard key={data._id} data={data} link="/album/" />;
          })}
        </div>
        <h4 className="text-white text-xl font-semibold">Shows to try</h4>
        <div className="flex flex-wrap">
          {songs
            .filter((data) => data.type == "podcast")
            .map((data) => {
              return <SongCard key={data._id} data={data} link="/shows/" />;
            })}
        </div>
        <h4 className="text-white text-xl font-semibold">Trending now</h4>
        <div className="flex flex-wrap">
          {songs
            .filter((data) => data.type == "song")
            .map((data) => {
              return <SongCard key={data._id} data={data} link="/album/" />;
            })}
        </div>
        <h4 className="text-white text-xl font-semibold">
          More like Devi Sri Prasad
        </h4>
        <div className="flex flex-wrap">
          {songs
            .filter((data) => data.singer == "Devi Sri Prasad")
            .map((data) => {
              return <SongCard key={data._id} data={data} link="/album/" />;
            })}
        </div>
      </div>
    </>
  );
}

export default Home;
